import React, { useState, useEffect } from 'react';
import { Package, Gem, Plus, TrendingUp, TrendingDown, History, ArrowUpCircle, ArrowDownCircle, Save, X, Search, User } from 'lucide-react';
import HistoriqueOrOuvrier from './HistoriqueOrOuvrier';
import { API_URL } from '../../services/api';

const CoffresOuvriers = ({ preSelectedOuvrier = null }) => {
  const [coffres, setCoffres] = useState([]);
  const [filteredCoffres, setFilteredCoffres] = useState([]);
  const [searchOuvrier, setSearchOuvrier] = useState('');
  const [selectedOuvrier, setSelectedOuvrier] = useState(preSelectedOuvrier);
  const [detailsMatieres, setDetailsMatieres] = useState([]);
  const [detailsPierres, setDetailsPierres] = useState([]);
  const [mouvements, setMouvements] = useState([]);
  const [stockDisponible, setStockDisponible] = useState([]);
  const [showMouvement, setShowMouvement] = useState(false);
  const [showModalDiamant, setShowModalDiamant] = useState(false);
  const [formMouvement, setFormMouvement] = useState({
    type_mouvement: 'ENTREE',
    type_matiere: '',
    reference_matiere: '',
    quantite: '',
    description: ''
  });
  const [searchMatiere, setSearchMatiere] = useState('');
  const [filteredMatieres, setFilteredMatieres] = useState([]);
  const [showMatiereSuggestions, setShowMatiereSuggestions] = useState(false);
  const [formDiamant, setFormDiamant] = useState({
    type_mouvement: 'ENTREE',
    reference: '',
    quantite: '',
    description: ''
  });
  const [searchDiamant, setSearchDiamant] = useState('');
  const [filteredDiamants, setFilteredDiamants] = useState([]);

  useEffect(() => {
    loadCoffres();
    loadStockDisponible();
  }, []);

  useEffect(() => {
    if (preSelectedOuvrier && coffres.length > 0) {
      const ouvrier = coffres.find(c => c.ouvrier_id === preSelectedOuvrier.id);
      if (ouvrier) {
        handleSelectOuvrier(ouvrier);
      }
    }
  }, [preSelectedOuvrier, coffres]);

  const loadStockDisponible = async () => {
    try {
      const [matieresRes, pierresRes] = await Promise.all([
        fetch(`${API_URL}/coffres/stock-matieres`),
        fetch(`${API_URL}/coffres/pierres`)
      ]);
      const matieres = await matieresRes.json();
      const pierres = await pierresRes.json();
      
      console.log('Stock chargé:', {
        matieres: matieres?.length || 0,
        pierres: pierres?.length || 0,
        exemplesPierres: pierres?.slice(0, 3)
      });
      
      setStockDisponible({
        matieres: Array.isArray(matieres) ? matieres : [],
        pierres: Array.isArray(pierres) ? pierres : []
      });
    } catch (error) {
      console.error('Erreur chargement stock:', error);
      setStockDisponible({ matieres: [], pierres: [] });
    }
  };

  const loadCoffres = async () => {
    try {
      const response = await fetch(`${API_URL}/coffres/ouvriers`);
      const data = await response.json();
      setCoffres(Array.isArray(data) ? data : []);
      
      // Appliquer le filtre de recherche si actif
      if (searchOuvrier.trim() === '') {
        setFilteredCoffres(data || []);
      } else {
        const filtered = (data || []).filter(c => 
          c.nom?.toLowerCase().includes(searchOuvrier.toLowerCase()) ||
          c.prenom?.toLowerCase().includes(searchOuvrier.toLowerCase())
        );
        setFilteredCoffres(filtered);
      }
    } catch (error) {
      console.error('Erreur chargement coffres:', error);
    }
  };

  const handleSearchOuvrier = (value) => {
    setSearchOuvrier(value);
    if (value.trim() === '') {
      setFilteredCoffres(coffres);
    } else {
      const filtered = coffres.filter(c => 
        c.nom?.toLowerCase().includes(value.toLowerCase()) ||
        c.prenom?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCoffres(filtered);
    }
  };

  const loadDetailsOuvrier = async (ouvrierId) => {
    try {
      const [matieresRes, pierresRes, mouvementsRes] = await Promise.all([
        fetch(`${API_URL}/coffres/ouvriers/${ouvrierId}/matieres`),
        fetch(`${API_URL}/coffres/ouvriers/${ouvrierId}/pierres`),
        fetch(`${API_URL}/coffres/ouvriers/${ouvrierId}/mouvements`)
      ]);

      const matieres = await matieresRes.json();
      const pierres = await pierresRes.json();
      const mouvs = await mouvementsRes.json();

      setDetailsMatieres(matieres);
      setDetailsPierres(pierres);
      setMouvements(mouvs);
    } catch (error) {
      console.error('Erreur chargement détails:', error);
    }
  };

  const handleSelectOuvrier = (ouvrier) => {
    setSelectedOuvrier(ouvrier);
    loadDetailsOuvrier(ouvrier.ouvrier_id);
  };

  const ajouterMouvement = async () => {
    if (!selectedOuvrier || !formMouvement.quantite || !formMouvement.description) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    // Vérifier si c'est une sortie et si la quantité disponible est suffisante
    if (formMouvement.type_mouvement === 'SORTIE') {
      const matiereSelectionnee = detailsMatieres.find(m => m.reference === formMouvement.reference_matiere);
      const quantiteDisponible = matiereSelectionnee ? parseFloat(matiereSelectionnee.quantite_grammes) : 0;
      const quantiteDemandee = parseFloat(formMouvement.quantite);
      
      if (quantiteDemandee > quantiteDisponible) {
        alert(`❌ Quantité insuffisante !\n\nDisponible : ${quantiteDisponible.toFixed(2)}g\nDemandé : ${quantiteDemandee.toFixed(2)}g\n\nVous ne pouvez pas retirer plus que ce que l'ouvrier possède.`);
        return;
      }
    }

    try {
      const response = await fetch(
        `${API_URL}/coffres/ouvriers/${selectedOuvrier.ouvrier_id}/mouvement`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type_mouvement: formMouvement.type_mouvement,
            type_matiere: formMouvement.type_matiere,
            quantite: parseFloat(formMouvement.quantite),
            description: formMouvement.description
          })
        }
      );

      if (response.ok) {
        alert('✅ Mouvement enregistré avec succès !');
        setFormMouvement({ type_mouvement: 'ENTREE', type_matiere: '', reference_matiere: '', quantite: '', description: '' });
        setSearchMatiere('');
        setShowMouvement(false);
        
        // Recharger les données pour mettre à jour l'affichage
        await loadCoffres();
        await loadDetailsOuvrier(selectedOuvrier.ouvrier_id);
      } else {
        const error = await response.json();
        alert(`❌ Erreur: ${error.error}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('❌ Erreur lors de l\'ajout du mouvement');
    }
  };

  const resetCoffre = async () => {
    const totalOr = detailsMatieres.reduce((sum, m) => sum + parseFloat(m.quantite_grammes || 0), 0);
    const totalPierres = detailsPierres.reduce((sum, p) => sum + parseFloat(p.quantite || 0), 0);

    if (totalOr === 0 && totalPierres === 0) {
      alert('Le coffre est déjà vide.');
      return;
    }

    const msg = `⚠️ RÉINITIALISER LE COFFRE DE ${selectedOuvrier.prenom?.toUpperCase()} ${selectedOuvrier.nom?.toUpperCase()} ?\n\n` +
      `Tout le contenu sera retourné au stock principal :\n` +
      (totalOr > 0 ? `• Or : ${totalOr.toFixed(2)}g\n` : '') +
      (totalPierres > 0 ? `• Pierres : ${totalPierres.toFixed(3)}ct\n` : '') +
      `\nCette action est irréversible.`;

    if (!window.confirm(msg)) return;

    try {
      const res = await fetch(`${API_URL}/coffres/ouvriers/${selectedOuvrier.ouvrier_id}/reset-coffre`, { method: 'POST' });
      const data = await res.json();
      if (res.ok) {
        const mouvs = data.mouvements_retour || [];
        const details = mouvs.map(m => `• ${m.reference} : ${parseFloat(m.quantite).toFixed(2)}${m.unite || 'g'}`).join('\n');
        alert(`✅ Coffre remis à zéro !\n\nRetourné au stock :\n${details || 'Aucun élément'}`);
        await loadCoffres();
        await loadDetailsOuvrier(selectedOuvrier.ouvrier_id);
      } else {
        alert(`❌ Erreur: ${data.error}`);
      }
    } catch (e) {
      console.error('Erreur reset coffre:', e);
      alert('❌ Erreur lors de la réinitialisation');
    }
  };

  const calculerSolde = (mouvements, index) => {
    let solde = 0;
    for (let i = 0; i <= index; i++) {
      const mouv = mouvements[i];
      if (mouv.type_mouvement === 'ENTREE') {
        solde += parseFloat(mouv.quantite || 0);
      } else {
        solde -= parseFloat(mouv.quantite || 0);
      }
    }
    return solde;
  };

  return (
    <div className="min-h-screen bg-gray-50 p-3 sm:p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">🔐 Gestion des Coffres Ouvriers</h1>

        {!selectedOuvrier ? (
          /* Vue centrée - Aucun ouvrier sélectionné */
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                  <User className="h-6 w-6 text-blue-600" />
                  Ouvriers
                </h2>
                <span className="text-sm text-gray-500 bg-blue-100 px-2 py-1 rounded-full font-semibold">
                  {filteredCoffres.length}
                </span>
              </div>
              
              {/* Barre de recherche */}
              <div className="mb-4 relative">
                <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  value={searchOuvrier}
                  onChange={(e) => handleSearchOuvrier(e.target.value)}
                  placeholder="Rechercher un ouvrier..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {searchOuvrier && (
                  <button
                    onClick={() => handleSearchOuvrier('')}
                    className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
                  >
                    <X size={18} />
                  </button>
                )}
              </div>

              {/* Liste des ouvriers (affichage en ligne) */}
              <div className="space-y-3 max-h-[calc(100vh-300px)] overflow-y-auto pr-2">
                {filteredCoffres.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <User className="h-12 w-12 mx-auto mb-2 opacity-30" />
                    <p className="text-sm">Aucun ouvrier trouvé</p>
                  </div>
                ) : (
                  filteredCoffres.map((coffre) => (
                    <div
                      key={coffre.ouvrier_id}
                      className="p-4 rounded-lg transition-all border-2 bg-white border-blue-200 hover:border-blue-400 hover:shadow-lg"
                    >
                      <div className="flex items-center gap-4">
                        {/* Photo ou initiales de l'ouvrier */}
                        <div className="flex-shrink-0">
                          {coffre.photo_url ? (
                            <img
                              src={coffre.photo_url.startsWith('http') ? coffre.photo_url : `${API_URL.replace('/api', '')}${coffre.photo_url}`}
                              alt={`${coffre.prenom} ${coffre.nom}`}
                              className="w-16 h-16 rounded-full object-cover border-2 border-blue-300 shadow-md"
                            />
                          ) : (
                            <div className="w-16 h-16 rounded-full flex items-center justify-center font-bold text-white bg-gradient-to-br from-blue-500 to-blue-700 text-xl shadow-md">
                              {coffre.prenom?.charAt(0)}{coffre.nom?.charAt(0)}
                            </div>
                          )}
                        </div>
                        
                        {/* Nom de l'ouvrier */}
                        <div className="flex-1">
                          <p className="font-bold text-gray-800 text-lg">{coffre.prenom?.toUpperCase()} {coffre.nom?.toUpperCase()}</p>
                        </div>
                        
                        {/* Icônes Or et Diamant en ligne */}
                        <div className="flex gap-3">
                          {/* Icône Or */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectOuvrier(coffre);
                              setShowMouvement(true);
                            }}
                            className="group relative bg-gradient-to-br from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 rounded-xl p-3 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 min-w-[100px]"
                          >
                            <div className="text-center">
                              <div className="text-3xl mb-1">🪙</div>
                              <div className="font-bold text-white text-base">{coffre.total_matieres_grammes.toFixed(1)}g</div>
                              <div className="text-xs text-yellow-100 font-semibold">OR</div>
                            </div>
                          </button>
                          
                          {/* Icône Diamant */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectOuvrier(coffre);
                              setShowModalDiamant(true);
                            }}
                            className="group relative bg-gradient-to-br from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 rounded-xl p-3 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 min-w-[100px]"
                          >
                            <div className="text-center">
                              <div className="text-3xl mb-1">💎</div>
                              <div className="font-bold text-white text-base">{coffre.total_pierres_carats.toFixed(2)}ct</div>
                              <div className="text-xs text-purple-100 font-semibold">PIERRES</div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        ) : (
          /* Vue avec sidebar - Ouvrier sélectionné */
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Liste des ouvriers */}
            <div className="col-span-1 bg-white rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                <User className="h-6 w-6 text-blue-600" />
                Ouvriers
              </h2>
              <span className="text-sm text-gray-500 bg-blue-100 px-2 py-1 rounded-full font-semibold">
                {filteredCoffres.length}
              </span>
            </div>
            
            {/* Barre de recherche */}
            <div className="mb-4 relative">
              <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
              <input
                type="text"
                value={searchOuvrier}
                onChange={(e) => handleSearchOuvrier(e.target.value)}
                placeholder="Rechercher un ouvrier..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {searchOuvrier && (
                <button
                  onClick={() => handleSearchOuvrier('')}
                  className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
                >
                  <X size={18} />
                </button>
              )}
            </div>

            {/* Liste des ouvriers */}
            <div className="space-y-3 max-h-[600px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
              {filteredCoffres.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <User className="h-12 w-12 mx-auto mb-2 opacity-30" />
                  <p className="text-sm">Aucun ouvrier trouvé</p>
                </div>
              ) : (
                filteredCoffres.map((coffre) => (
                  <div
                    key={coffre.ouvrier_id}
                    onClick={() => handleSelectOuvrier(coffre)}
                    className={`p-4 rounded-lg cursor-pointer transition-all border-2 ${
                      selectedOuvrier?.ouvrier_id === coffre.ouvrier_id
                        ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-500 shadow-md'
                        : 'bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300 hover:shadow-sm'
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      {coffre.photo_url ? (
                        <img
                          src={coffre.photo_url}
                          alt={`${coffre.prenom} ${coffre.nom}`}
                          className={`w-10 h-10 rounded-full object-cover border-2 ${
                            selectedOuvrier?.ouvrier_id === coffre.ouvrier_id
                              ? 'border-blue-600'
                              : 'border-gray-400'
                          }`}
                        />
                      ) : (
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                          selectedOuvrier?.ouvrier_id === coffre.ouvrier_id
                            ? 'bg-blue-600'
                            : 'bg-gray-400'
                        }`}>
                          {coffre.prenom?.charAt(0)}{coffre.nom?.charAt(0)}
                        </div>
                      )}
                      <div className="flex-1">
                        <p className="font-bold text-gray-800">{coffre.prenom} {coffre.nom}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div className="bg-yellow-50 rounded px-2 py-1 flex items-center gap-1">
                        <Package size={14} className="text-yellow-600" />
                        <span className="font-semibold text-yellow-800">{coffre.total_matieres_grammes.toFixed(2)}g</span>
                      </div>
                      <div className="bg-purple-50 rounded px-2 py-1 flex items-center gap-1">
                        <Gem size={14} className="text-purple-600" />
                        <span className="font-semibold text-purple-800">{coffre.total_pierres_carats.toFixed(2)}ct</span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Détails du coffre */}
          <div className="col-span-1 lg:col-span-2 space-y-6 max-h-[calc(100vh-120px)] overflow-y-auto pr-0 lg:pr-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
            {selectedOuvrier ? (
              <>
                {/* ── BOÎTE OR : vue style logiciel professionnel ── */}
                <div className="bg-white rounded-lg border border-gray-200 shadow overflow-hidden">
                  {/* Header boîte */}
                  <div className="flex items-center justify-between px-4 py-3 border-b" style={{ background: '#1a7abf' }}>
                    <div className="text-sm font-bold text-white tracking-wide">
                      Boîte : {selectedOuvrier.prenom} {selectedOuvrier.nom}
                    </div>
                    <div className="text-white text-sm font-semibold">
                      Solde : <span className="text-yellow-300 font-bold text-base ml-1">
                        {calculerSolde(mouvements, mouvements.length - 1).toFixed(2)} g
                      </span>
                    </div>
                  </div>

                  {/* Table mouvements style comptable */}
                  {mouvements.length > 0 ? (() => {
                    // Trier du plus ancien au plus récent et calculer le solde progressif
                    const sorted = [...mouvements].sort((a, b) =>
                      new Date(a.date_mouvement) - new Date(b.date_mouvement));
                    let running = 0;
                    const withSolde = sorted.map(m => {
                      if (m.type_mouvement === 'ENTREE') running += parseFloat(m.quantite || 0);
                      else running -= parseFloat(m.quantite || 0);
                      return { ...m, _solde: running };
                    });
                    // Afficher du plus récent au plus ancien
                    const display = [...withSolde].reverse();
                    return (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr style={{ background: '#e8eef3' }}>
                            <th className="px-3 py-2 text-left text-xs font-bold text-gray-700 border-b border-gray-300">Date</th>
                            <th className="px-3 py-2 text-left text-xs font-bold text-gray-700 border-b border-gray-300">Type</th>
                            <th className="px-3 py-2 text-right text-xs font-bold text-gray-700 border-b border-gray-300">Qté</th>
                            <th className="px-3 py-2 text-right text-xs font-bold text-gray-700 border-b border-gray-300">Solde</th>
                            <th className="px-3 py-2 text-left text-xs font-bold text-gray-700 border-b border-gray-300">Commentaire</th>
                          </tr>
                        </thead>
                        <tbody>
                          {display.map((m, index) => {
                            const isEntree = m.type_mouvement === 'ENTREE';
                            const commentaire = m.motif || m.description || (m.type_ressource || m.type_matiere || '');
                            return (
                              <tr key={m.id} className="border-b border-gray-100 hover:bg-blue-50 transition-colors" style={{ background: index % 2 === 0 ? '#fff' : '#f8fafc' }}>
                                <td className="px-3 py-1.5 text-xs text-gray-600 whitespace-nowrap">
                                  {new Date(m.date_mouvement).toLocaleDateString('fr-FR')}
                                </td>
                                <td className="px-3 py-1.5 whitespace-nowrap">
                                  <span className={`text-xs font-bold ${isEntree ? 'text-blue-600' : 'text-gray-800'}`}>
                                    {isEntree ? 'Entrée' : 'Sortie'}
                                  </span>
                                </td>
                                <td className={`px-3 py-1.5 text-right text-xs font-bold whitespace-nowrap ${isEntree ? 'text-blue-600' : 'text-red-600'}`}>
                                  {isEntree ? '+' : '-'}{parseFloat(m.quantite).toFixed(2)}
                                </td>
                                <td className={`px-3 py-1.5 text-right text-xs font-bold whitespace-nowrap ${m._solde < 0 ? 'text-red-600' : 'text-gray-900'}`}>
                                  {m._solde.toFixed(2)}
                                </td>
                                <td className="px-3 py-1.5 text-xs text-gray-700 max-w-xs truncate">
                                  {commentaire}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    );
                  })() : (
                    <div className="p-6 text-center text-gray-400 text-sm">
                      Aucun mouvement — Ajoutez une entrée d'or pour commencer
                    </div>
                  )}
                </div>

                {/* Icônes Or et Diamant - Interface simplifiée */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Icône Or */}
                  <button
                    onClick={() => setShowMouvement(true)}
                    className="bg-gradient-to-br from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105"
                  >
                    <div className="text-center">
                      <div className="text-6xl mb-3">🪙</div>
                      <div className="font-bold text-white text-2xl">{detailsMatieres.reduce((sum, m) => sum + parseFloat(m.quantite_grammes || 0), 0).toFixed(1)}g</div>
                      <div className="text-sm text-yellow-100 font-semibold mt-1">GÉRER L'OR</div>
                    </div>
                  </button>
                  
                  {/* Icône Diamant */}
                  <button
                    onClick={() => setShowModalDiamant(true)}
                    className="bg-gradient-to-br from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105"
                  >
                    <div className="text-center">
                      <div className="text-6xl mb-3">💎</div>
                      <div className="font-bold text-white text-2xl">{detailsPierres.reduce((sum, p) => sum + parseFloat(p.quantite || 0), 0).toFixed(2)}ct</div>
                      <div className="text-sm text-purple-100 font-semibold mt-1">GÉRER LES PIERRES</div>
                    </div>
                  </button>
                </div>

                {/* Reset coffre */}
                {(detailsMatieres.reduce((s, m) => s + parseFloat(m.quantite_grammes || 0), 0) > 0 ||
                  detailsPierres.reduce((s, p) => s + parseFloat(p.quantite || 0), 0) > 0) && (
                  <div className="flex justify-end">
                    <button
                      onClick={resetCoffre}
                      className="flex items-center gap-2 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 border border-red-300 rounded-lg font-semibold text-sm transition-colors"
                    >
                      🔄 Remettre à zéro le coffre
                    </button>
                  </div>
                )}

                {/* Modal Or Simplifié */}
                {showMouvement && (
                  <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-6 border-2 border-yellow-300 shadow-lg">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-2xl font-bold text-yellow-800 flex items-center gap-2">
                        🪙 Gestion de l'Or
                      </h3>
                      <button onClick={() => setShowMouvement(false)} className="text-gray-500 hover:text-gray-700">
                        <X size={24} />
                      </button>
                    </div>

                    {/* Boutons Entrée / Sortie */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <button
                        onClick={() => {
                          setFormMouvement({...formMouvement, type_mouvement: 'ENTREE'});
                          setSearchMatiere('');
                          setFilteredMatieres([]);
                        }}
                        className={`p-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-2 ${
                          formMouvement.type_mouvement === 'ENTREE'
                            ? 'bg-green-600 text-white shadow-lg'
                            : 'bg-white text-gray-700 hover:bg-green-50 border-2 border-green-300'
                        }`}
                      >
                        📈 Entrée
                      </button>
                      <button
                        onClick={() => {
                          setFormMouvement({...formMouvement, type_mouvement: 'SORTIE'});
                          setSearchMatiere('');
                          setFilteredMatieres([]);
                        }}
                        className={`p-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-2 ${
                          formMouvement.type_mouvement === 'SORTIE'
                            ? 'bg-red-600 text-white shadow-lg'
                            : 'bg-white text-gray-700 hover:bg-red-50 border-2 border-red-300'
                        }`}
                      >
                        📉 Sortie
                      </button>
                    </div>

                    {/* Référence avec Autocomplétion */}
                    <div className="mb-4">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Référence</label>
                      
                      {formMouvement.type_mouvement === 'SORTIE' ? (
                        // Mode SORTIE : Sélection parmi ce que l'ouvrier possède
                        <select
                          value={formMouvement.reference_matiere}
                          onChange={(e) => {
                            const selected = detailsMatieres.find(m => m.reference === e.target.value);
                            setFormMouvement({
                              ...formMouvement,
                              type_matiere: selected?.type || '',
                              reference_matiere: e.target.value
                            });
                          }}
                          className="w-full px-4 py-3 border-2 border-yellow-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-yellow-500"
                        >
                          <option value="">Sélectionner...</option>
                          {detailsMatieres.length > 0 ? (
                            detailsMatieres.map((m, idx) => (
                              <option key={idx} value={m.reference}>
                                {m.reference} - {m.type} - {parseFloat(m.quantite_grammes).toFixed(2)}g
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>Aucun or disponible</option>
                          )}
                        </select>
                      ) : (
                        // Mode ENTRÉE : Autocomplétion avec stock disponible
                        <div className="relative">
                          <input
                            type="text"
                            value={searchMatiere}
                            onChange={(e) => {
                              const value = e.target.value;
                              setSearchMatiere(value);
                              
                              if (value.length >= 1) {
                                // Rechercher dans le stock disponible
                                const matieres = stockDisponible.matieres || [];
                                const filtered = matieres.filter(m =>
                                  m.type?.toLowerCase().includes(value.toLowerCase()) ||
                                  m.reference?.toLowerCase().includes(value.toLowerCase())
                                );
                                setFilteredMatieres(filtered);
                                setShowMatiereSuggestions(true); // Toujours afficher si on tape
                              } else {
                                // Afficher toutes les matières si le champ est vide
                                setFilteredMatieres(stockDisponible.matieres || []);
                                setShowMatiereSuggestions(false);
                              }
                            }}
                            onFocus={() => {
                              // Afficher toutes les options au focus
                              if (searchMatiere.length === 0) {
                                setFilteredMatieres(stockDisponible.matieres || []);
                              }
                              setShowMatiereSuggestions(true);
                            }}
                            placeholder="Tapez 'or' pour voir les options..."
                            className="w-full px-4 py-3 border-2 border-yellow-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-yellow-500"
                          />
                          
                          {/* Suggestions */}
                          {showMatiereSuggestions && filteredMatieres.length > 0 && (
                            <div className="absolute z-50 w-full mt-1 bg-white border-2 border-yellow-300 rounded-lg shadow-xl max-h-80 overflow-y-auto">
                              {filteredMatieres.map((matiere, idx) => (
                                <div
                                  key={idx}
                                  onClick={() => {
                                    setFormMouvement({
                                      ...formMouvement,
                                      type_matiere: matiere.type,
                                      reference_matiere: matiere.reference
                                    });
                                    setSearchMatiere(matiere.reference);
                                    setShowMatiereSuggestions(false);
                                  }}
                                  className="px-4 py-3 hover:bg-yellow-50 cursor-pointer border-b last:border-b-0 transition-colors"
                                >
                                  <div className="flex justify-between items-center gap-4">
                                    <div className="flex-1">
                                      <div className="font-bold text-gray-900 text-base">{matiere.reference}</div>
                                      <div className="text-sm text-gray-600 mt-0.5">{matiere.type}</div>
                                    </div>
                                    <div className="text-right">
                                      <div className="font-bold text-green-600 text-lg">
                                        {parseFloat(matiere.quantite_stock || 0).toFixed(2)}g
                                      </div>
                                      <div className="text-xs text-gray-500 mt-0.5">Stock bijouterie</div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Quantité */}
                    <div className="mb-4">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Quantité (grammes)</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={formMouvement.quantite}
                        onChange={(e) => setFormMouvement({...formMouvement, quantite: e.target.value})}
                        placeholder="Ex: 15.50"
                        className="w-full px-4 py-3 border-2 border-yellow-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-yellow-500"
                      />
                    </div>

                    {/* Commentaire */}
                    <div className="mb-6">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Commentaire</label>
                      <input
                        type="text"
                        value={formMouvement.description}
                        onChange={(e) => setFormMouvement({...formMouvement, description: e.target.value})}
                        placeholder="OR18K, REBUT-LIMAI, etc."
                        className="w-full px-4 py-3 border-2 border-yellow-300 rounded-lg focus:ring-2 focus:ring-yellow-500"
                      />
                    </div>

                    {/* Boutons Actions */}
                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={ajouterMouvement}
                        className="py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-lg shadow-lg hover:shadow-xl transition-all"
                      >
                        ✅ Enregistrer
                      </button>
                      <button
                        onClick={() => setShowMouvement(false)}
                        className="py-3 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-bold text-lg shadow-lg hover:shadow-xl transition-all"
                      >
                        ✖ Annuler
                      </button>
                    </div>
                  </div>
                )}

                {/* Modal Diamant Simplifié */}
                {showModalDiamant && (
                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border-2 border-purple-300 shadow-lg">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-2xl font-bold text-purple-800 flex items-center gap-2">
                        💎 Gestion des Pierres
                      </h3>
                      <button onClick={() => setShowModalDiamant(false)} className="text-gray-500 hover:text-gray-700">
                        <X size={24} />
                      </button>
                    </div>

                    {/* Boutons Ajouter / Retirer */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <button
                        onClick={() => setFormDiamant({...formDiamant, type_mouvement: 'ENTREE'})}
                        className={`p-6 rounded-xl font-bold text-lg transition-all ${
                          formDiamant.type_mouvement === 'ENTREE'
                            ? 'bg-green-600 text-white shadow-lg scale-105'
                            : 'bg-white text-gray-700 hover:bg-green-50 border-2 border-green-300'
                        }`}
                      >
                        ➕ AJOUTER
                      </button>
                      <button
                        onClick={() => setFormDiamant({...formDiamant, type_mouvement: 'SORTIE'})}
                        className={`p-6 rounded-xl font-bold text-lg transition-all ${
                          formDiamant.type_mouvement === 'SORTIE'
                            ? 'bg-red-600 text-white shadow-lg scale-105'
                            : 'bg-white text-gray-700 hover:bg-red-50 border-2 border-red-300'
                        }`}
                      >
                        ➖ RETIRER
                      </button>
                    </div>

                    {/* Référence Pierre avec Autocomplétion */}
                    <div className="mb-4">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Référence</label>
                      
                      {formDiamant.type_mouvement === 'SORTIE' ? (
                        // Mode SORTIE : Sélection parmi ce que l'ouvrier possède
                        <select
                          value={formDiamant.reference}
                          onChange={(e) => setFormDiamant({...formDiamant, reference: e.target.value})}
                          className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-purple-500"
                        >
                          <option value="">Sélectionner...</option>
                          {detailsPierres.length > 0 ? (
                            detailsPierres.map((pierre, idx) => (
                              <option key={idx} value={pierre.reference}>
                                {pierre.reference} - {parseFloat(pierre.quantite).toFixed(3)}ct
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>Aucune pierre disponible</option>
                          )}
                        </select>
                      ) : (
                        // Mode ENTRÉE : Autocomplétion avec stock disponible
                        <div className="relative">
                          <input
                            type="text"
                            value={searchDiamant}
                            onChange={(e) => {
                              const value = e.target.value;
                              setSearchDiamant(value);
                              
                              if (value.length >= 1) {
                                const filtered = (stockDisponible.pierres || []).filter(p =>
                                  p.reference?.toLowerCase().includes(value.toLowerCase()) ||
                                  p.designation?.toLowerCase().includes(value.toLowerCase())
                                );
                                setFilteredDiamants(filtered);
                              } else {
                                // Afficher toutes les pierres si le champ est vide
                                setFilteredDiamants(stockDisponible.pierres || []);
                              }
                            }}
                            onFocus={() => {
                              // Afficher toutes les options au focus
                              if (searchDiamant.length === 0) {
                                setFilteredDiamants(stockDisponible.pierres || []);
                              }
                            }}
                            placeholder="Tapez pour voir les pierres..."
                            className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-purple-500"
                          />
                          {filteredDiamants.length > 0 && (
                            <div className="absolute z-50 w-full mt-1 bg-white border-2 border-purple-300 rounded-lg shadow-xl max-h-80 overflow-y-auto">
                              {filteredDiamants.map((pierre, idx) => (
                                <div
                                  key={idx}
                                  onClick={() => {
                                    setFormDiamant({...formDiamant, reference: pierre.reference});
                                    setSearchDiamant(pierre.reference);
                                    setFilteredDiamants([]);
                                  }}
                                  className="px-4 py-3 hover:bg-purple-50 cursor-pointer border-b last:border-b-0 transition-colors"
                                >
                                  <div className="flex justify-between items-center gap-4">
                                    <div className="flex-1">
                                      <div className="font-bold text-purple-900 text-base">{pierre.reference}</div>
                                      <div className="text-sm text-gray-600 mt-0.5">{pierre.designation || pierre.nom}</div>
                                    </div>
                                    <div className="text-right">
                                      <div className="font-bold text-green-600 text-lg">
                                        {parseFloat(pierre.quantite_stock || 0).toFixed(3)}ct
                                      </div>
                                      <div className="text-xs text-gray-500 mt-0.5">Stock bijouterie</div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Quantité */}
                    <div className="mb-4">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Quantité (carats)</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.001"
                        value={formDiamant.quantite}
                        onChange={(e) => setFormDiamant({...formDiamant, quantite: e.target.value})}
                        placeholder="Ex: 0.50"
                        className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg text-lg font-semibold focus:ring-2 focus:ring-purple-500"
                      />
                    </div>

                    {/* Description */}
                    <div className="mb-6">
                      <label className="block text-sm font-bold mb-2 text-gray-700">Description</label>
                      <input
                        type="text"
                        value={formDiamant.description}
                        onChange={(e) => setFormDiamant({...formDiamant, description: e.target.value})}
                        placeholder="Ex: Sertissage bague"
                        className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      />
                    </div>

                    {/* Bouton Valider */}
                    <button
                      onClick={async () => {
                        if (!formDiamant.reference || !formDiamant.quantite || !formDiamant.description) {
                          alert('Veuillez remplir tous les champs');
                          return;
                        }

                        // Vérifier si c'est une sortie et si la quantité disponible est suffisante
                        if (formDiamant.type_mouvement === 'SORTIE') {
                          const pierreSelectionnee = detailsPierres.find(p => p.reference === formDiamant.reference);
                          const quantiteDisponible = pierreSelectionnee ? parseFloat(pierreSelectionnee.quantite) : 0;
                          const quantiteDemandee = parseFloat(formDiamant.quantite);
                          
                          if (quantiteDemandee > quantiteDisponible) {
                            alert(`❌ Quantité insuffisante !\n\nDisponible : ${quantiteDisponible.toFixed(3)}ct\nDemandé : ${quantiteDemandee.toFixed(3)}ct\n\nVous ne pouvez pas retirer plus que ce que l'ouvrier possède.`);
                            return;
                          }
                        }

                        try {
                          const response = await fetch(
                            `${API_URL}/coffres/ouvriers/${selectedOuvrier.ouvrier_id}/mouvement-pierre`,
                            {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                type_mouvement: formDiamant.type_mouvement,
                                reference: formDiamant.reference,
                                quantite: parseFloat(formDiamant.quantite),
                                description: formDiamant.description
                              })
                            }
                          );

                          if (response.ok) {
                            alert('✅ Mouvement pierre enregistré avec succès !');
                            setFormDiamant({ type_mouvement: 'ENTREE', reference: '', quantite: '', description: '' });
                            setSearchDiamant('');
                            setShowModalDiamant(false);
                            
                            // Recharger les données
                            await loadCoffres();
                            await loadDetailsOuvrier(selectedOuvrier.ouvrier_id);
                          } else {
                            const error = await response.json();
                            alert(`❌ Erreur: ${error.error}`);
                          }
                        } catch (error) {
                          console.error('Erreur:', error);
                          alert('❌ Erreur lors de l\'ajout du mouvement pierre');
                        }
                      }}
                      className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transition-all"
                    >
                      ✅ VALIDER
                    </button>
                  </div>
                )}

                {/* Historique des Mouvements - Tableau détaillé */}
                <div className="bg-white rounded-lg shadow overflow-hidden">
                  <div className="bg-gradient-to-r from-gray-700 to-gray-800 text-white px-6 py-4">
                    <h3 className="text-lg font-bold flex items-center gap-2">
                      <History size={20} />
                      Historique des Mouvements - Boîte Ouvrier
                    </h3>
                  </div>
                  {mouvements.length > 0 ? (
                    <>
                      {/* Mobile cards */}
                      <div className="md:hidden divide-y divide-gray-100">
                        {mouvements.map((m, index) => {
                          const solde = calculerSolde(mouvements, index);
                          const isEntree = m.type_mouvement === 'ENTREE';
                          return (
                            <div key={m.id} className={`p-4 ${isEntree ? 'bg-blue-50' : 'bg-red-50'}`}>
                              <div className="flex justify-between items-start mb-1">
                                <div>
                                  <div className="font-semibold text-gray-800 text-sm">{m.type_ressource || m.type_matiere}</div>
                                  <div className="text-xs text-gray-500">{m.motif || m.description}</div>
                                  <div className="text-xs text-gray-400 mt-0.5">{new Date(m.date_mouvement).toLocaleDateString('fr-FR')}</div>
                                </div>
                                <div className="text-right">
                                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${isEntree ? 'bg-blue-600 text-white' : 'bg-red-600 text-white'}`}>
                                    {isEntree ? <ArrowUpCircle size={12} /> : <ArrowDownCircle size={12} />}
                                    {parseFloat(m.quantite).toFixed(2)}g
                                  </span>
                                  <div className="text-xs text-gray-600 mt-1">Solde: <span className="font-bold">{solde.toFixed(2)}g</span></div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className="bg-gray-50 px-4 py-3 flex justify-between items-center">
                          <span className="font-bold text-gray-700">Solde Final:</span>
                          <span className="text-xl font-bold text-blue-600">{calculerSolde(mouvements, mouvements.length - 1).toFixed(2)} g</span>
                        </div>
                      </div>
                      {/* Desktop table */}
                      <div className="hidden md:block overflow-x-auto">
                      <table className="w-full">
                        <thead className="bg-gray-100 border-b-2 border-gray-300">
                          <tr>
                            <th className="px-4 py-3 text-left font-bold text-gray-700">Date</th>
                            <th className="px-4 py-3 text-left font-bold text-gray-700">Type</th>
                            <th className="px-4 py-3 text-right font-bold text-gray-700">Qté (g)</th>
                            <th className="px-4 py-3 text-right font-bold text-gray-700">Solde (g)</th>
                            <th className="px-4 py-3 text-left font-bold text-gray-700">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mouvements.map((m, index) => {
                            const solde = calculerSolde(mouvements, index);
                            const isEntree = m.type_mouvement === 'ENTREE';
                            return (
                              <tr
                                key={m.id}
                                onClick={() => {
                                  // Ouvrir le modal mouvement uniquement pour les matières (or)
                                  if (m.type_ressource !== 'PIERRE') {
                                    setShowMouvement(true);
                                    setFormMouvement({
                                      type_mouvement: 'SORTIE',
                                      type_matiere: m.type_matiere || 'OR18K',
                                      quantite: '',
                                      description: ''
                                    });
                                  }
                                }}
                                className={`border-b hover:bg-gray-100 cursor-pointer transition-colors ${
                                  isEntree ? 'bg-blue-50' : 'bg-red-50'
                                }`}
                              >
                                <td className="px-4 py-3 text-sm">
                                  {new Date(m.date_mouvement).toLocaleDateString('fr-FR')}
                                </td>
                                <td className="px-4 py-3">
                                  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold ${
                                    isEntree
                                      ? 'bg-blue-600 text-white'
                                      : 'bg-red-600 text-white'
                                  }`}>
                                    {isEntree ? (
                                      <ArrowUpCircle size={14} />
                                    ) : (
                                      <ArrowDownCircle size={14} />
                                    )}
                                    {m.type_mouvement}
                                  </span>
                                </td>
                                <td className={`px-4 py-3 text-right font-bold ${
                                  isEntree ? 'text-blue-600' : 'text-red-600'
                                }`}>
                                  {parseFloat(m.quantite).toFixed(2)}
                                </td>
                                <td className="px-4 py-3 text-right font-bold text-gray-900">
                                  {solde.toFixed(2)}
                                </td>
                                <td className="px-4 py-3 text-sm text-gray-700">
                                  <div className="font-semibold">{m.type_ressource || m.type_matiere}</div>
                                  <div className="text-xs text-gray-500">{m.motif || m.description}</div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="bg-gray-50 px-6 py-4 border-t-2 border-gray-300">
                        <div className="flex justify-between items-center">
                          <span className="font-bold text-gray-700">Solde Final:</span>
                          <span className="text-2xl font-bold text-blue-600">
                            {calculerSolde(mouvements, mouvements.length - 1).toFixed(2)} g
                          </span>
                        </div>
                      </div>
                      </div>
                    </>
                  ) : (
                    <div className="p-12 text-center">
                      <History size={48} className="mx-auto text-gray-300 mb-3" />
                      <p className="text-gray-500">Aucun mouvement enregistré</p>
                      <p className="text-sm text-gray-400 mt-1">Ajoutez des entrées/sorties pour suivre le stock</p>
                    </div>
                  )}
                </div>

                {/* Historique des mouvements d'or par fiche de fabrication */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  <HistoriqueOrOuvrier 
                    ouvrierId={selectedOuvrier.ouvrier_id} 
                    ouvrierNom={`${selectedOuvrier.prenom} ${selectedOuvrier.nom}`}
                  />
                </div>
              </>
            ) : (
              <div className="bg-white rounded-lg shadow p-12 text-center">
                <Package size={64} className="mx-auto text-gray-300 mb-4" />
                <p className="text-gray-500 text-lg">Sélectionnez un ouvrier pour voir son coffre</p>
              </div>
            )}
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default CoffresOuvriers;
